module.exports = __webpack_public_path__ + "static/profile-d402bdb9e6d1b659423fd5409a0d7db3.png";